import React, {FC, HTMLAttributes, useId} from 'react';
import styled from 'styled-components';

interface RadioButtonProps extends HTMLAttributes<HTMLInputElement> {
    label?: string
    checked?: boolean
    name?: string
    value?: any
}


const RadioButtonLabel = styled.label`
    background: #3B5049;
    color: #fff;
    padding: 20px;
    border-radius: 15px; 
    text-align: center;
    text-transform: uppercase;
    font-size: 1rem;
    transition: all .3s;
    cursor: pointer;
    display: flex;
    flex: calc(100% - 35px);
    @media screen and (min-width: 600px) {
        flex: calc(50% - 35px);
        padding: 40px;
    }
    @media screen and (min-width: 900px) {
        flex: calc(33.33% - 35px);
        padding: 70px;
    }
    align-content: center;
    justify-content: center;
    align-items: center;
    user-select: none;
`;

const RadioButtonInput = styled.input.attrs({ type: 'radio' })`
  display: none;
  &:checked + ${RadioButtonLabel} {
    background: #ADC2A3;
    color: #fff;
  }
  &:hover + ${RadioButtonLabel} {
    background: #ADC2A3;
    color: #fff;
  }
`;

const RadioButton: FC<RadioButtonProps> = ({label, checked, id, ...otherProps}) => {

    const customId = useId()

    return (
        <>
            <RadioButtonInput id={id || customId} {...otherProps} checked={checked} />
            {label && <RadioButtonLabel className={"survey-radio-button"} dangerouslySetInnerHTML={{__html: label}} htmlFor={id || customId} />}
        </>
      )
}

export default RadioButton
